/* js/modal.js */

;(function($, window, document) {

    $(document).on('ready', function() {

        var $trigger = $('.messe-livechat--trigger'),
            $target = $('.messe-livechat'),
            openCls = 'is--open';

        $trigger.on('click', function(){
            $target.toggleClass(openCls);
        });

    });

})(jQuery, window, document);